import { cn } from '../../lib/cn';
import type { CodingStandardRow } from '../../engineeringgovernance/framework';

type Props = { standards?: CodingStandardRow[] };

export function CodingConstitutionPanel({ standards = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {standards.map((s) => (
        <div key={s.standard} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{s.standard}</p>
          <p className="mt-1 text-xs text-slate-500">{s.rule}</p>
          <span className={cn(
            'mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-medium',
            s.status === 'enforced' || s.status === 'mandatory'
              ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
              : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
          )}>
            {s.status}
          </span>
        </div>
      ))}
    </div>
  );
}
